import { render } from "./Pagination.vue?vue&type=template&id=b05e57ca&scoped=true&ts=true"
import script from "./Pagination.vue?vue&type=script&lang=ts"
export * from "./Pagination.vue?vue&type=script&lang=ts"

import "./Pagination.vue?vue&type=style&index=0&id=b05e57ca&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b05e57ca"]])

export default __exports__